import { connect } from 'react-redux'
import { goBack } from 'react-router-redux'
import moment from 'moment'
import get from 'lodash/get'

import WorkTrackerDatePicker from '../../components/work-trackers/work-tracker-date-picker'
import { setDatePeriodFilterForLocation } from '../../actions/work-tracker-filters'

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.locationId
  const contractId = get(state, `workTrackerFilters.${id}.contractId`)
  const contract = get(state, `contracts.${contractId}`)

  return {
    modalTitle: 'Choose a Date Range',
    minDate: contract.startDate,
    maxDate: contract.endDate,
    initialValues: {
      startPeriod: contract.startDate,
      endPeriod: contract.endDate
    }
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId

  return {
    onSubmit (data) {
      const { startPeriod, endPeriod } = data
      dispatch(setDatePeriodFilterForLocation(id, { startPeriod, endPeriod }))
      dispatch(goBack())
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkTrackerDatePicker)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-date-picker-container.js